//
// ICUPackage.js
// sasicu
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "@sas-dvr/ltjs-commons/PortablePackage";

var ICUPackage = createModule("sasicu::ICUPackage", ["commons::PortablePackage"], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getMinimalRelativeAssetPaths: [[7],[7]],
    },
    {
        instance: [1],
    },
    ,
]);
export default ICUPackage;
